 $(document).ready(function(){
      // mobile validation
  //   $('body').on('keyup', '.buyer-email', function() {
  //   var maxDigits = 10;
  //   $(this).attr("maxlength", maxDigits);
  //   var phoneNum1 = $(this).val().replace(/\s/g, '');
  //   var phone_regex1 = /^[6789][0-9]{4}([ ]?)[0-9]{5}$/;
  //   var email_regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   var errorMsg = '';
  //   if (phone_regex1.test(phoneNum1)) {
  //     $('.email-me-submitButton').prop('disabled', false);
  //     $(this).parents('.field').find('.error-msg-mail').html('Please enter valid email id');
  //   } else {
  //     $('.email-me-submitButton').prop('disabled', true);
  //     $('.buyer-email').focus();
  //     errorMsg = $(this).attr('placeholder');
  //     $(this).parents('.field').find('.error-msg-phone').html('Please enter a valid number');
  //   }
  // });
     $('body').on('click','.cstm-product-atc-btn',function(e){
       var product_name = $(this).attr('data-product-title');
        var product_id = $(this).attr('data-product-id');
        $('#product_id').text(product_id);
       $('#product_name_input').text(product_name);
       $('.popup-pincode.notify').show();

        const phoneInput = document.querySelector(".buyer-phone-number");
        const hiddenInput = document.querySelector(".notify_popup_content input[name='contact[tags]']");
    
        phoneInput.addEventListener("input", function () {
            hiddenInput.value = `Notify me_${phoneInput.value}_${product_name}`;
        });
       
     });
      $('.email-me-button').click(function(){
      var email_val = $('.buyer-email').val();
      var name_val = $('.buyer-name').val();
      if (email_val === '' || name_val === '') {
        $('.error-msg2').text('* Your Contact Info is Invalid').show();
      }else{
        $(".successSub").show();
            $(".successSub").removeClass("hidden_popup");
            $(".popup-pincode").hide();
             setTimeout(function() {
                $(".successSub").hide();
                $(".popup-pincode.notify").hide();
                $('.buyer-email').val('');
                $('.buyer-name').val('');
             }, 2500);
      }
    });
     $('.buyer-email').keyup(function(){
        $('.error-msg2').hide();
      });

      $('.successSub_header').after().click(function() {
        $('.successSub').hide();
      });
          $('.cross_btn_desktop_only').click(function(){
        $('.popup-pincode.notify').hide();
      });
     }) ;


const notifySubmitButton = document.querySelector('.notify_popup_content button[type="submit"]');
const notifyForm = document.querySelector(".notify_popup_content #contact_form");

const notifyEmailInput = notifyForm?.querySelector('[name="contact[email]"]');
const notifyPhoneInput = notifyForm?.querySelector('[name="phone"]');
const notifyConsentInput = notifyForm?.querySelector('[type="checkbox"]');

const emailError = notifyForm?.querySelector('.error-msg-mail');
const phoneError = notifyForm?.querySelector('.error-msg-phone');
const consentError = notifyForm?.querySelector('.error-msg-consent');

// Regex patterns
const phone_regex = /^[6789]\d{9}$/;
const email_regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Live validation on keyup
if (notifyEmailInput) {
  notifyEmailInput.addEventListener('keyup', function () {
    const value = this.value.trim();
    if (email_regex.test(value)) {
      emailError && (emailError.innerHTML = '');
    } else {
      emailError && (emailError.innerHTML = 'Please enter a valid email');
    }
  });
}

if (notifyPhoneInput) {
  notifyPhoneInput.addEventListener('keyup', function () {
    const value = this.value.trim().replace(/\s/g, '');
    if (phone_regex.test(value)) {
      phoneError && (phoneError.innerHTML = '');
    } else {
      phoneError && (phoneError.innerHTML = 'Please enter a valid 10-digit phone number');
    }
  });
}

// Submit logic
if (notifySubmitButton && notifyForm) {
  notifySubmitButton.addEventListener("click", function (event) {
    event.preventDefault();

    const notifyEmail = notifyEmailInput?.value.trim() || '';
    const notifyPhone = notifyPhoneInput?.value.trim().replace(/\s/g, '') || '';
    const checkConsent = notifyConsentInput?.checked || false;

    let isValid = true;

    // Reset errors
    if (!email_regex.test(notifyEmail)) {
      emailError && (emailError.innerHTML = 'Please enter a valid email');
      isValid = false;
    } else {
      emailError && (emailError.innerHTML = '');
    }

    if (!phone_regex.test(notifyPhone)) {
      phoneError && (phoneError.innerHTML = 'Please enter a valid 10-digit phone number');
      isValid = false;
    } else {
      phoneError && (phoneError.innerHTML = '');
    }

    if (!checkConsent) {
      consentError && (consentError.innerHTML = 'Please accept the consent to proceed.');
      isValid = false;
    } else {
      consentError && (consentError.innerHTML = '');
    }

    if (!isValid) return;

    // Proceed with API call
    const header_value = {
      isoLanguage: "EN",
      isoCountry: "IN",
      brandCode: "BH0992",
      campaignId: "PN002385",
      campaignDescription: "Always On",
      origin: "https://www.simpleskincare.in/",
      formType: "signUp",
      entity: "PRM2.6",
    };

    const x_api_key = "b2930cbc-ae89-41f5-ad6a-32491386660d";

    const consumerIdentity = {
      firstName: "N/A",
      lastName: "N/A",
    };

    const contactDetail = {
      email: notifyEmail,
      mobileNumber: `+91${notifyPhone}`,
    };

    const optInStatus = {
      legalAgeConsent: checkConsent,
      unileverEmailConsent: checkConsent,
      unileverSMSConsent: checkConsent,
    };

    const data_value = JSON.stringify({
      profile: {
        header: header_value,
        consumerIdentity,
        contactDetail,
        optInStatus,
      },
    });

    fetch("https://forms-sg.unileversolutions.com/v3", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": x_api_key,
      },
      body: data_value,
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        console.log("Success:", data);
        notifyForm.submit(); // Submit to Shopify only if successful
      })
      .catch((error) => {
        console.error("Error:", error);
        notifyForm.submit(); // Still submit to Shopify in fallback
      });
  });
}

